import { render, staticRenderFns } from "./_pomucka.vue?vue&type=template&id=7ec5cc76&scoped=true&"
import script from "./_pomucka.vue?vue&type=script&lang=js&"
export * from "./_pomucka.vue?vue&type=script&lang=js&"
import style0 from "./_pomucka.vue?vue&type=style&index=0&id=7ec5cc76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec5cc76",
  null
  
)

export default component.exports